<template>
    <div class="container">
        <div class="tickets-payment-info">
            <div class="card payment-card background-circle">
                <h3>{{ title }}</h3>
                <div v-if="list && list.length > 0" class="payment-options">
                    <div v-for="method in list" :class="method.content ? 'content' : 'item'">
                        <div v-if="method.content" v-html="method.content"></div>
                        <div v-else>
                            <span class="icon-wrap" v-html="method.icon"></span>
                            {{ method.title }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="card background-circle" v-html="content"></div>
        </div>
    </div>
</template>

<style lang="scss">
    .tickets-payment-info .card {
        a {
            color: var(--color-blue-highlight);
        }

        p {
            line-height: 1.8rem;
        }

        h3 {
            font-size: 2.4rem;
            line-height: 1.25em;
            margin: 0;
        }

        h3 + .why {
            margin-top: 24px;
        }

        .why {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 15px 0;

            .icon-wrap {
                min-width: 40px;
                text-align: center;
                margin: 0;
            }

            p {
                font-size: 1rem;
                padding-left: 8px;
                line-height: 1.27em;
                margin: 0;
            }

            @media (min-width: 992px) {
                padding-right: 70px;

                p {
                    font-size: 1.2rem;
                    padding-left: 16px;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .tickets-payment-info {
        padding: 40px 0;

        .card {
            margin: 0;
            width: 100%;
            padding: 16px;
            border-radius: 20px;
            background: linear-gradient(90deg, #5B1AD1 0%, #7500BF 100%);
            color: #FFFFFF;

            &:last-child {
                margin-top: 24px;
                background: linear-gradient(90deg, #E90B7E 0%, #FF5A5A 100%);
            }
        }

        .payment-options {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;
            margin: 40px 0 24px;

            .item {
                text-align: center;
                width: calc(100% / 3);
                margin-bottom: 16px;
                white-space: nowrap;
            }

            .content {
                display: block;
                width: 100%;
                margin-top: 20px;
            }

            .icon-wrap {
                display: block;
                margin-bottom: 8px;
            }
        }

        @media (min-width: 768px) {
            display: flex;
            justify-content: space-between;

            .card {
                width: calc(50% - 10px);

                &:last-child {
                    margin-top: 0;
                }
            }
        }

        @media (min-width: 992px) {
            .payment-options .item {
                width: calc(100% / 6);
            }

            .card {
                padding: 60px 40px 50px;
            }
        }
    }
</style>

<script>
    import SvgIcon from '../general/SvgIcon.vue'

    export default {
        props: {
            title: String,
            content: String,
            list: {
                type: Array,
                required: true,
            },
        },

        components: {
            SvgIcon
        },
    }
</script>
